import { Field }                       from '$/entities/lib/JSONable';
import BasePreferences, { Preference } from '$/entities/lib/BasePreferences';
import { EntityID }                    from '$/entities/BaseEntity';

export enum ReferralMethod {
	Email    = 'email',
	Facebook = 'facebook',
}

// keys are the class names of the actions
export enum DismissedActionKeys {
	DelegateSetup = 'delegateSetup',
}

export class BaseRolePreferences extends BasePreferences {

	// Common field for tracking dismissed dashboard actions by class name
	@Field()
	dismissedActions: Partial<Record<DismissedActionKeys, boolean>> = {};

	// Common field for tracking whether to receive particular emails
	@Field()
	emails: Partial<Dictionary<Preference>> = {};

}

export interface CreateReferralResponse {
	discountApplied: boolean;
	url?: string; // social platform url to refer another user on
}

export interface ReferralInfo {
	id: EntityID; 	// couponID
	description: string;
	canApply: boolean;
	hasApplied: boolean;
}
